<template>
  <auth-box :error="error">
    <div>
      <div ref="loginFormContainer"></div>

      <div
        v-if="features.login.includes(authMethod.Native)"
        class="divider"
      ></div>

      <p
        v-if="features.login.includes(authMethod.Native)"
        class="mt-3 mb-2 text-center"
      >
        {{ $t("auth.noAccountYet") }}
        <a href="/register" data-testid="register-link">{{
          $t("auth.register")
        }}</a>
      </p>
    </div>
  </auth-box>
</template>

<script>
import { mapGetters } from "vuex";
import AuthBox from "./auth_box.vue";
import {
  hideDisabledAuthMethods,
  updateGoogleButtonLabel,
  updateFormTitle,
  waitForSignInMount,
} from "./utils";
import { AuthMethod } from "@/components/auth/auth_methods";

export default {
  name: "LoginForm",

  components: {
    AuthBox,
  },

  inject: ["growthBook"],

  data() {
    return {
      email: "",
      password: "",
      error: "",
      isLoading: false,
      authMethod: AuthMethod,
    };
  },

  computed: {
    ...mapGetters("config", ["features"]),
  },
  async mounted() {
    const clerk = this.$getClerk();
    await clerk.load();
    const container = this.$refs.loginFormContainer;

    clerk.mountSignIn(container, {
      oauthFlow: "popup",
    });
    await waitForSignInMount(container);

    this.applyAuthMethodsCustomization(container);

    this.observer = new MutationObserver(() => {
      this.observer.disconnect();
      this.applyAuthMethodsCustomization(container);
      this.observer.observe(container, { childList: true, subtree: true });
    });
    this.observer.observe(container, { childList: true, subtree: true });

    window.addEventListener("hashchange", this.handleHashChange);
  },

  beforeDestroy() {
    this.observer?.disconnect();
    window.removeEventListener("hashchange", this.handleHashChange);
  },
  methods: {
    applyAuthMethodsCustomization(container) {
      hideDisabledAuthMethods(container, this.features.login);
      updateFormTitle(container, this.$t("auth.loginToEssayGrader"));

      if (this.features.login.includes(AuthMethod.Google)) {
        updateGoogleButtonLabel(container, this.$t("auth.loginWithGoogle"));
      }
    },

    handleHashChange() {
      const container = this.$refs.loginFormContainer;
      if (!container) return;

      setTimeout(() => {
        this.applyAuthMethodsCustomization(container);
      }, 10);
    },
  },
};
</script>
